import { createFileRoute } from '@tanstack/react-router';

import { SessionRolloverPage } from '~pages/sessions';

export const Route = createFileRoute('/_auth/_layout/sessions/rollover')({
  component: RouteComponent,
});

function RouteComponent() {
  return <SessionRolloverPage />;
}
